import { AIScribeLinkedUserModel } from "@/AIScribe/Models/AIScribeLinkedUserModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { AIScribeStore } from "../AIScribeStore";

class AIScribeHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.AIScribe.ShowAIScribePopup, this.showAIScribePopup);
        this.RegisterOperation(LocalOperations.AIScribe.CloseAIScribePopup, this.closeAIScribePopup);
        this.RegisterOperation(LocalOperations.AIScribe.ShowAIScribeSubscriptionExpiredPopup, this.showAIScribeSubscriptionExpiredPopup);
        this.RegisterOperation(LocalOperations.AIScribe.CloseAIScribeSubscriptionExpiredPopup, this.closeAIScribeSubscriptionExpiredPopup);
        this.RegisterOperation(LocalOperations.AIScribe.ShowAIScribeLinkPopup, this.showAIScribeLinkPopup);
        this.RegisterOperation(LocalOperations.AIScribe.CloseAIScribeLinkPopup, this.closeAIScribeLinkPopup);
        this.RegisterOperation(LocalOperations.AIScribe.ShowAIScribeWarningActiveAssistant, this.showAIScribeWarningActiveAssistant);
        this.RegisterOperation(LocalOperations.AIScribe.CloseAIScribeWarningActiveAssistant, this.closeAIScribeWarningActiveAssistant);
        this.RegisterOperation(LocalOperations.AIScribe.ShowAIScribeMarketingPopup, this.showAIScribeMarketingPopup);
        this.RegisterOperation(LocalOperations.AIScribe.CloseAIScribeMarketingPopup, this.closeAIScribeMarketingPopup);
        this.RegisterOperation(LocalOperations.AIScribe.RemindMeLaterAIScribeMarketingPopup, this.remindMeLaterAIScribeMarketingPopup);
        this.RegisterOperation(LocalOperations.AIScribe.CloseAIScribeUnlinkCarewayPopup, this.closeAIScribeUnlinkCarewayPopup);
        this.RegisterOperation(LocalOperations.AIScribe.ShowAIScribeUnlinkCarewayPopup, this.showAIScribeUnlinkCarewayPopup);
    }

    private showAIScribePopup(request: LocalEvent, store: AIScribeStore): void {
        const patientContactId = request.Get<string>("patientContactId");
        const patientContactFacetId = request.Get<string>("patientContactFacetId");
        const encounterId = request.Get<string>("encounterId");
        const aiScribeConsultationId = request.Get<string>("aiScribeConsultationId");
        const aiScribeUrl = request.Get<string>("aiScribeUrl");
        const openBottomPos = request.Get<number>("openBottomPos");
        const openRightPos = request.Get<number>("openRightPos");

        store.Model = store.Model
            .set("PatientContactId", patientContactId)
            .set("PatientContactFacetId", patientContactFacetId)
            .set("EncounterId", encounterId)
            .set("AIScribeConsultationId", aiScribeConsultationId)
            .set("AIScribeConsultationUrl", aiScribeUrl)
            .set("ShowAIScribePopup", true)
            .set("AIScribePopupBottomPos", openBottomPos)
            .set("AIScribePopupRightPos", openRightPos);
    }

    private closeAIScribePopup(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model
            .set("PatientContactId", "")
            .set("PatientContactFacetId", "")
            .set("EncounterId", "")
            .set("AIScribeConsultationId", "")
            .set("AIScribeConsultationUrl", "")
            .set("ShowAIScribePopup", false);
    }

    private showAIScribeSubscriptionExpiredPopup(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model.set("ShowSubscriptionExpiredPopup", true);
    }

    private closeAIScribeSubscriptionExpiredPopup(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model.set("ShowSubscriptionExpiredPopup", false);
    }

    private showAIScribeLinkPopup(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model
            .set("ShowAIScribeLinkPopup", true)
            .set("ShowAIScribeMarketingPopup", false);
    }

    private closeAIScribeLinkPopup(request: LocalEvent, store: AIScribeStore): void {
        const linkedUser = request.Get<AIScribeLinkedUserModel>("user");
        if (linkedUser) {
            store.Model = store.Model
                .set("AIScribeLinkedUser", linkedUser)
                .set("ShowSubscriptionExpiredPopup", !linkedUser.hasSubscription());
        }

        store.Model = store.Model
            .set("ShowAIScribeLinkPopup", false);
    }

    private showAIScribeWarningActiveAssistant(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model.set("ShowAIScribeWarningActiveAssistant", true);
    }

    private closeAIScribeWarningActiveAssistant(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model.set("ShowAIScribeWarningActiveAssistant", false);
    }

    private showAIScribeMarketingPopup(request: LocalEvent, store: AIScribeStore): void {
        const patientContactId = request.Get<string>("patientContactId");
        const patientContactFacetId = request.Get<string>("patientContactFacetId");
        const encounterId = request.Get<string>("encounterId");
        const openBottomPos = request.Get<number>("openBottomPos");
        const openRightPos = request.Get<number>("openRightPos");

        store.Model = store.Model
            .set("ShowAIScribeMarketingPopup", true)
            .set("PatientContactId", patientContactId)
            .set("PatientContactFacetId", patientContactFacetId)
            .set("EncounterId", encounterId)
            .set("AIScribePopupBottomPos", openBottomPos)
            .set("AIScribePopupRightPos", openRightPos);
    }

    private closeAIScribeMarketingPopup(_: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model
            .set("ShowAIScribeMarketingPopup", false);
    }

    private remindMeLaterAIScribeMarketingPopup(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model
            .set("DisableAIScribeMarketingPopup", true);

        this.closeAIScribeMarketingPopup(request, store);
    }

    private showAIScribeUnlinkCarewayPopup(request: LocalEvent, store: AIScribeStore): void {
        store.Model = store.Model.set("ShowAIScribeUnlinkPopup", true);
    }

    private closeAIScribeUnlinkCarewayPopup(request: LocalEvent, store: AIScribeStore): void {
        const unlinkUser = request.Get<boolean>("unlinkUser");
        if (unlinkUser) {
            store.Model = store.Model
                .set("AIScribeLinkedUser", null)
                .set("ShowSubscriptionExpiredPopup", false);
        }
        store.Model = store.Model.set("ShowAIScribeUnlinkPopup", false);
    }
}

export { AIScribeHandler };
